<template>
  <div class="text-center">
    <button
      class="bg-white h-16 w-16 mx-auto rounded-full text-purple-500 font-bold text-xl"
      @click="openModal = true"
    >
      {{ (instancesInfo[instanceID] ? getInitials(instancesInfo[instanceID].name) : '') }}
    </button>
    <portal to="instance-picker">
      <modal
        :open="openModal"
        type="informative"
        @close="resetModal"
      >
        <div slot="content">
          <div
            class="block text-center my-0 px-0 relative rounded-md"
          >
            <eva-icon
              class="absolute left-0 my-2 mx-2"
              name="search-outline"
              fill="#282A43"
            />
            <input
              ref="instancePickerInput"
              class="w-full h-10 pl-10 text-purple-500 border-2 border-purple-500 border-opacity-0 focus:border-opacity-100"
              type="text"
              placeholder="Buscar instancia"
              :value="searchValue"
              @input="searchValue = $event.target.value"
            >
          </div>
          <div
            v-if="parsedInstancesInfo.length === 0"
            class="mt-4"
          >
            <img
              class="mx-auto w-3/6 opacity-50"
              src="@/assets/empty.svg"
              alt="Empty"
            >
            <div class="mt-4 text-lg text-center">
              ¡Vaya! Parece que no encontramos esa instancia.
            </div>
          </div>
          <div
            v-for="(instanceInfo, index) in parsedInstancesInfo"
            :key="instanceInfo.instanceID"
            :class="`my-2 bg-${instanceID === instanceInfo.instanceID ? 'purple-500' : 'gray-100'} border border-purple-500 border-opacity-0 hover:border-opacity-100`"
            @click="setInstance(instanceInfo.instanceID)"
          >
            <button
              :class="`flex space-between text-${instanceID === instanceInfo.instanceID ? 'white font-bold' : 'gray-500'}`"
            >
              <div class="bg-gray-500 flex-shrink-0 h-full text-white text-center w-8 align-middle py-4">
                {{ index + 1 }}
              </div>
              <div class="p-4 truncate">
                {{ instanceInfo.name }}
              </div>
            </button>
          </div>
        </div>
      </modal>
    </portal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Modal from '../components/modal'
export default {
  name: 'InstancePicker',
  components: {
    Modal,
  },
  props: {
  },
  data () {
    return {
      openModal: false,
      searchValue: '',
    }
  },
  computed: {
    parsedInstancesInfo () {
      const found = []
      for (const instanceInfo of Object.values(this.instancesInfo)) {
        if (this.account.support || (typeof this.account.administrator !== 'undefined' && this.account.administrator.includes(instanceInfo.instanceID))) {
          if (instanceInfo.name) {
            if (this.searchValue.trim() === '') {
              found.push(instanceInfo)
            } else if (instanceInfo.name.toLowerCase().includes(this.searchValue.toLowerCase())) {
              found.push(instanceInfo)
            }
          }
        }
      }
      return found.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    },
    ...mapState({
      account: state => state.auth.account,
      instancesInfo: state => state.auth.instancesInfo,
      instanceID: state => state.admin.instanceID,
    }),
  },
  watch: {
    openModal () {
      if (this.openModal) {
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$refs.instancePickerInput.focus()
          })
        })
      }
    },
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    resetModal () {
      this.openModal = false
      this.searchValue = ''
    },
    setInstance (instanceID) {
      this.$emit('picked')
      this.$store.commit('admin/setInstanceID', instanceID)
      this.openModal = false
      this.searchValue = ''
    },
    getInitials (name) {
      if (name) {
        const nameArray = (name).split(' ')
        return nameArray[0][0] + (nameArray[1] ? nameArray[1][0].toUpperCase() : nameArray[0][1].toLowerCase())
      }
      return ''
    },
  },
}
</script>
<style lang="scss">
@import "../css/_brand";
</style>
